export const HTTP_PROTOCOL = import.meta.env.VITE_HTTP_PROTOCOL;
export const SEARCH_SUB_URL = import.meta.env.VITE_SEARCH_SUB_URL;
export const USER_SUB_URL = import.meta.env.VITE_USER_SUB_URL;
export const IXIO_WEB_URL = import.meta.env.VITE_IXIO_WEB_URL;
